import {Stack, useBreakpointUp} from '@travel-frontend/core';
import {Flex} from '@travel-frontend/ui-components';
import {memo} from 'react';

import {KeywordTypes} from '@/api/keywordApi';
import {LayoutContainer} from '@/components/LayoutContainer';
import {useSeaCampaign} from '@/modules/common/context/SeaCampaign';
import {useDestination} from '@/modules/common/hooks/useDestination';
import {Badge} from '@/modules/hotels/components/SeaSpotlight/components/Badge';
import {Body} from '@/modules/hotels/components/SeaSpotlight/components/Body';
import {Container} from '@/modules/hotels/components/SeaSpotlight/components/Container';
import {Headline} from '@/modules/hotels/components/SeaSpotlight/components/Headline';
import {Subline} from '@/modules/hotels/components/SeaSpotlight/components/Subline';

export const SeaSpotlight: React.FunctionComponent = memo(
  function SeaSpotlight() {
    const seaCampaign = useSeaCampaign();
    const destination = useDestination();
    const lgUp = useBreakpointUp('lg');

    if (!seaCampaign.active || destination.type === KeywordTypes.hotel) {
      return null;
    }

    return (
      <Container backgroundImageUrl={seaCampaign.config?.teaserImageUrl || ''}>
        <LayoutContainer>
          <Body direction="row" justifyContent="space-between">
            <Stack>
              <Headline>
                {[
                  seaCampaign.config?.headlinePrefix || '',
                  destination.keyword?.keyword || '',
                ]
                  .filter(Boolean)
                  .join(' ')}
              </Headline>
              <Subline>{seaCampaign.config?.subline || ''}</Subline>
            </Stack>
            <Flex direction="row" alignItems="center">
              {seaCampaign.config &&
                seaCampaign.config.badges?.length &&
                seaCampaign.config.badges
                  .slice(0, lgUp ? 3 : 1)
                  .map((badge, index) => <Badge data={badge} key={index} />)}
            </Flex>
          </Body>
        </LayoutContainer>
      </Container>
    );
  }
);
